import React from 'react';
import NodeWrapper from './NodeWrapper';
import Sensor from './themes/classic/Sensor';

const CustomInput = (props) => {

  const iconStyle = {
    // left: '45%'
  }

  return (
    <NodeWrapper noEdit {...props}>
      <Sensor props={props} iconStyle={iconStyle} />
    
    </NodeWrapper>
  );
};

export default CustomInput;
